import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../assets/css/icons.css';
import '../../assets/css/style.css'
import { SERVER_IP, PORT, ud, jwt, auth_response_flow } from '../../Server'
import axios from 'axios';
import 'react-dropdown-tree-select/dist/styles.css'
import $ from 'jquery';


var imgPrefix = `${SERVER_IP}/icons`
class EditUser extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            Lists: {},
            user_action: "view",
            tempList: {},
            image: ""
        }
    }


    viewInfo = () => {
        var data = {
            s_id: "",
            user_id: ud.id,
            user_type: ud.usertype
        }
        let _this = this;
        let headers = {
            'user_id': (ud.id).toString(),
            'session_id': (ud.session_id).toString(),
            'user_type': (ud.usertype).toString(),
            'main_id': (ud.main_id).toString(),
            'jwt_token': (jwt),
            'c_id': (ud.c_id).toString()
        }
        axios.post(`${SERVER_IP}/usersList`, data, { withCredentials: true, headers: headers })
            .then(function (response) {
                if (response.data.error == false) {
                    if (response.data.usersList) {
                        if (response.data.usersList.length == 1) {
                            _this.setState({ Lists: response.data.usersList[0], tempList: response.data.usersList[0], message: response.data.usersList.length === 0 ? "No Record Found." : "" });
                        }
                    }
                } else {
                    auth_response_flow(response.data, (return_response) => {
                        if (return_response.error === false && return_response.retry === true) {
                            _this.viewInfo();
                        }
                    })
                }
            })
            .catch(function (error) {
                console.log(error);
            });
    }

    componentDidMount() {
        this.viewInfo();

        // this.getTotalType()
        var current = this
        $(".btnrating").on('click', (function (e) {

            var previous_value = $("#selected_rating").val();

            var selected_value = $(this).attr("data-attr");
            current.setState({ rating: selected_value })
            $("#selected_rating").val(selected_value);

            $(".selected-rating").empty();
            $(".selected-rating").html(selected_value);

            for (var i = 1; i <= selected_value; ++i) {
                $("#rating-star-" + i).toggleClass('btn-warning');
                $("#rating-star-" + i).toggleClass('btn-default');
            }

            for (var ix = 1; ix <= previous_value; ++ix) {
                $("#rating-star-" + ix).toggleClass('btn-warning');
                $("#rating-star-" + ix).toggleClass('btn-default');
            }

        }));
    }



    render() {
  
        const { errors } = this.state;
        return (
            <div>
                <div class="xp-breadcrumbbar">
                    <div class="row">
                        <div class="col-md-6 col-lg-6">
                            <h3 className="xp-page-title">Site Profile</h3>
                        </div>
                        <div class="col-md-12 col-lg-12">
                            <div class="xp-breadcrumb">
                                <ol class="breadcrumb">
                                    <li class="breadcrumb-item"><a onClick={() => window.location.href = "/dashboard"}><i class="icon-home"></i></a></li>
                                    <li class="breadcrumb-item active">Site Profile</li>
                                </ol>
                            </div>
                        </div>
                    </div>

                    <div className="xp-contentbar">
                        <div className="row">
                            <div className="">
                                <div className="card m-b-30">
                                    <div className="card-header bg-primary">
                                        <h5 className="card-title text-white">Site Profile</h5>
                                    </div>
                                    <div className="card-body">
                                        <div class="xp-social-profile-middle text-center">
                                            <div class="row">
                                                <div class="col-12">

                                                    <div class="xp-social-profile-title">
                                                        <h5 class="my-1 text-black">{this.state.Lists.site_name}</h5>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                        <ul className="profile-list">
                                            <li><label>Name</label><p>{this.state.Lists.name}</p></li>
                                            <li><label>Email</label><p>{this.state.Lists.email}</p></li>
                                            <li><label>Phone</label><p>{this.state.Lists.phone}</p></li>
                                            <li><label>Address</label>{this.state.Lists.address}<p></p></li>
                                            <li><label>City</label><p>{this.state.Lists.city}</p></li>
                                            <li><label>State</label><p>{this.state.Lists.state}</p></li>
                                            <li><label>ZIP</label><p>{this.state.Lists.zip}</p></li>

                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>


        )
    }
}
export default EditUser

const validEmailRegex = RegExp(/^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i);
const validateForm = (errors) => {
    let valid = true;
    Object.values(errors).forEach(
        (val) => val.length > 0 && (valid = false)
    );
    return valid;
}